/* global googletag */
/* eslint no-undef: "error" */

export default {
  watch: {
    adsInitialized () {
      const ignoreRoutenames = ['UserProfile', 'MyProfile', 'Reviewdetail', 'BestBusiness-Category']
      if (this.adsInitialized === this.totalAds && !ignoreRoutenames.includes(this._routeName)) {
        googletag.cmd.push(() => {
          googletag.pubads().setTargeting('Pagetype', this._routeName)
          googletag.pubads().setTargeting('URL', window.location.href)
          googletag.pubads().collapseEmptyDivs()
          googletag.enableServices()
        })
      }
    }
  },
  methods: {
    updateAdCounter () {
      this.adsInitialized++
    },
    loadAds (nameOverride = this.$route.name) {
      this._routeName = nameOverride
      const isMobile = window.innerWidth <= 767
      this.isMobileAds = window.isMobileAds = isMobile
      const adConfig = require('../misc/ad_config_object.js')

      if (!isMobile || (isMobile && typeof adConfig.mobile[nameOverride] !== 'undefined')) {
        this.adsInitialized = 0
        this.totalAds = isMobile ? adConfig.mobile[nameOverride].length : adConfig.desktop[nameOverride].length
        const m = (_index, data) => {
          return {
            index: _index + 1,
            slotName: data.slotName,
            slotParams: data.slotParams,
            targetingParams: data.targetingParams
          }
        }

        const _data = isMobile ? adConfig.mobile[nameOverride] : adConfig.desktop[nameOverride]
        let [one, two, three, four, five, six, seven] = [{}, {}, {}, {}, {}, {}, {}]
        _data.forEach((data, index) => {
          switch (index) {
            case 0:
              one = m(index, data)
              break
            case 1:
              two = m(index, data)
              break
            case 2:
              three = m(index, data)
              break
            case 3:
              four = m(index, data)
              break
            case 4:
              five = m(index, data)
              break
            case 5:
              six = m(index, data)
              break
            default:
              seven = m(index, data)
              break
          }
        })

        this.firstAd = one
        this.secondAd = two
        this.thirdAd = three
        this.fourthAd = four
        this.fifthAd = five
        this.sixthAd = six
        this.seventhAd = seven
      }
    }
  },
  beforeCreate () {
    window.googletag.cmd.push(() => {
      window.googletag.destroySlots()
    })
  },
  data () {
    return {
      adsInitialized: 0,
      totalAds: 0,
      isMobileAds: false,
      hideFirstDesktopAd: true,
      firstAd: {},
      secondAd: {},
      thirdAd: {},
      fourthAd: {},
      fifthAd: {},
      sixthAd: {},
      seventhAd: {},
      _routeName: this.$route.name
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/ad_config.js